var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheatSheet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_12",
    "data-name": "Group 12",
    xmlns: "http://www.w3.org/2000/svg",
    width: 1207,
    height: 811,
    viewBox: "0 0 1207 811",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #e8e8e8;\n      }\n\n      .cls-1, .cls-10, .cls-12, .cls-2, .cls-6, .cls-8 {\n        stroke: #707070;\n      }\n\n      .cls-2 {\n        fill: #f0f0f0;\n      }\n\n      .cls-16, .cls-3, .cls-4, .cls-5 {\n        fill: #707070;\n      }\n\n      .cls-3 {\n        font-size: 50px;\n      }\n\n      .cls-11, .cls-3, .cls-4, .cls-5, .cls-7, .cls-9 {\n        font-family: HelveticaNeue, Helvetica Neue;\n      }\n\n      .cls-4, .cls-7 {\n        font-size: 30px;\n      }\n\n      .cls-5, .cls-9 {\n        font-size: 18px;\n      }\n\n      .cls-6 {\n        fill: #ce84c5;\n      }\n\n      .cls-11, .cls-7, .cls-9 {\n        fill: #fff;\n      }\n\n      .cls-8 {\n        fill: #2b2b2b;\n      }\n\n      .cls-10 {\n        fill: #bccc4f;\n      }\n\n      .cls-11 {\n        font-size: 25px;\n      }\n\n      .cls-12 {\n        fill: #80c6e5;\n      }\n\n      .cls-13 {\n        fill: #e35646;\n      }\n\n      .cls-14, .cls-16 {\n        stroke: none;\n      }\n\n      .cls-15 {\n        fill: none;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_9",
    "data-name": "Rectangle 9",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    width: 1207,
    height: 811,
    rx: 5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 0.5,
    y: 0.5,
    width: 1206,
    height: 810,
    rx: 4.5
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_3",
    "data-name": "Rectangle 3",
    className: "cls-2",
    transform: "translate(32 272)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    width: 1136,
    height: 82,
    rx: 5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 0.5,
    y: 0.5,
    width: 1135,
    height: 81,
    rx: 4.5
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(-284 -158)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Influences",
    className: "cls-3",
    transform: "translate(316 213)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Influences")), /*#__PURE__*/React.createElement("text", {
    id: "Action",
    className: "cls-3",
    transform: "translate(640 213)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Action")), /*#__PURE__*/React.createElement("text", {
    id: "Effect",
    className: "cls-3",
    transform: "translate(910 213)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Effect")), /*#__PURE__*/React.createElement("text", {
    id: "Counteraction",
    className: "cls-3",
    transform: "translate(1135 213)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Counteraction")))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(-284 -158)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    className: "cls-2",
    transform: "translate(316 256)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    width: 1136,
    height: 82,
    rx: 5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 0.5,
    y: 0.5,
    width: 1135,
    height: 81,
    rx: 4.5
  })), /*#__PURE__*/React.createElement("text", {
    id: "_",
    "data-name": "\\u2014\\u2014\\u2014\\u2014\\u2014",
    className: "cls-4",
    transform: "translate(359 305)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2014\u2014\u2014\u2014\u2014")), /*#__PURE__*/React.createElement("text", {
    id: "Income",
    className: "cls-4",
    transform: "translate(663 305)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Income")), /*#__PURE__*/React.createElement("text", {
    id: "Collect_1_coin",
    "data-name": "Collect 1 coin",
    className: "cls-4",
    transform: "translate(886 305)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Collect 1 coin")), /*#__PURE__*/React.createElement("text", {
    id: "_2",
    "data-name": "\\u2014\\u2014\\u2014\\u2014\\u2014",
    className: "cls-4",
    transform: "translate(1212 305)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2014\u2014\u2014\u2014\u2014")))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(-284 -158)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2",
    "data-name": "Rectangle 2",
    className: "cls-2",
    transform: "translate(316 343)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    width: 1136,
    height: 82,
    rx: 5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 0.5,
    y: 0.5,
    width: 1135,
    height: 81,
    rx: 4.5
  })), /*#__PURE__*/React.createElement("text", {
    id: "_3",
    "data-name": "\\u2014\\u2014\\u2014\\u2014\\u2014",
    className: "cls-4",
    transform: "translate(359 392)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2014\u2014\u2014\u2014\u2014")), /*#__PURE__*/React.createElement("text", {
    id: "Foreign_Aid",
    "data-name": "Foreign Aid",
    className: "cls-4",
    transform: "translate(638 392)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Foreign Aid")), /*#__PURE__*/React.createElement("text", {
    id: "Collect_2_coins",
    "data-name": "Collect 2 coins",
    className: "cls-4",
    transform: "translate(875 392)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Collect 2 coins")), /*#__PURE__*/React.createElement("text", {
    id: "_4",
    "data-name": "\\u2014\\u2014\\u2014\\u2014\\u2014",
    className: "cls-4",
    transform: "translate(1212 392)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2014\u2014\u2014\u2014\u2014")))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    "data-name": "Group 11",
    transform: "translate(-284 -158)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4"
  }, /*#__PURE__*/React.createElement("text", {
    id: "_5",
    "data-name": "\\u2014\\u2014\\u2014\\u2014\\u2014",
    className: "cls-4",
    transform: "translate(359 479)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2014\u2014\u2014\u2014\u2014")), /*#__PURE__*/React.createElement("text", {
    id: "Coup",
    className: "cls-4",
    transform: "translate(677 479)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Coup")), /*#__PURE__*/React.createElement("text", {
    id: "Pay_7_coins",
    "data-name": "Pay 7 coins",
    className: "cls-4",
    transform: "translate(898 471)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Pay 7 coins")), /*#__PURE__*/React.createElement("text", {
    id: "_6",
    "data-name": "\\u2014\\u2014\\u2014\\u2014\\u2014",
    className: "cls-4",
    transform: "translate(1212 479)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2014\u2014\u2014\u2014\u2014"))), /*#__PURE__*/React.createElement("text", {
    id: "Make_any_player_lose_influence",
    "data-name": "Make any player lose influence",
    className: "cls-5",
    transform: "translate(857 492)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Make any player lose influence")))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5",
    transform: "translate(-280 -158)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_4",
    "data-name": "Rectangle 4",
    className: "cls-6",
    transform: "translate(312 517)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    width: 1136,
    height: 82,
    rx: 5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 0.5,
    y: 0.5,
    width: 1135,
    height: 81,
    rx: 4.5
  })), /*#__PURE__*/React.createElement("text", {
    id: "DUKE",
    className: "cls-7",
    transform: "translate(391 569)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "DUKE")), /*#__PURE__*/React.createElement("text", {
    id: "TAX",
    className: "cls-7",
    transform: "translate(686 569)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "TAX")), /*#__PURE__*/React.createElement("text", {
    id: "Collect_3_coins",
    "data-name": "Collect 3 coins",
    className: "cls-7",
    transform: "translate(879 569)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Collect 3 coins")), /*#__PURE__*/React.createElement("text", {
    id: "Block_Foreign_Aid",
    "data-name": "Block Foreign Aid",
    className: "cls-7",
    transform: "translate(1169 566)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Block Foreign Aid")))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6",
    transform: "translate(-284 -158)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_5",
    "data-name": "Rectangle 5",
    className: "cls-8",
    transform: "translate(316 604)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    width: 1136,
    height: 82,
    rx: 5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 0.5,
    y: 0.5,
    width: 1135,
    height: 81,
    rx: 4.5
  })), /*#__PURE__*/React.createElement("text", {
    id: "ASSASSIN",
    className: "cls-7",
    transform: "translate(359 656)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "ASSASSIN")), /*#__PURE__*/React.createElement("text", {
    id: "ASSASSINATE",
    className: "cls-7",
    transform: "translate(613 656)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "ASSASSINATE")), /*#__PURE__*/React.createElement("text", {
    id: "_7",
    "data-name": "\\u2014\\u2014\\u2014\\u2014\\u2014",
    className: "cls-7",
    transform: "translate(1211 656)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2014\u2014\u2014\u2014\u2014")), /*#__PURE__*/React.createElement("text", {
    id: "Pay_3_coins",
    "data-name": "Pay 3 coins",
    className: "cls-7",
    transform: "translate(898 648)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Pay 3 coins")), /*#__PURE__*/React.createElement("text", {
    id: "Make_any_player_lose_influence-2",
    "data-name": "Make any player lose influence",
    className: "cls-9",
    transform: "translate(857 669)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Make any player lose influence")))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group_8",
    "data-name": "Group 8",
    transform: "translate(-280 -177)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_6",
    "data-name": "Rectangle 6",
    className: "cls-10",
    transform: "translate(312 710)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    width: 1136,
    height: 82,
    rx: 5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 0.5,
    y: 0.5,
    width: 1135,
    height: 81,
    rx: 4.5
  })), /*#__PURE__*/React.createElement("text", {
    id: "AMBASSADOR",
    className: "cls-7",
    transform: "translate(329 762)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "AMBASSADOR")), /*#__PURE__*/React.createElement("text", {
    id: "EXCHANGE",
    className: "cls-7",
    transform: "translate(630 762)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "EXCHANGE")), /*#__PURE__*/React.createElement("text", {
    id: "Block_Stealing",
    "data-name": "Block Stealing",
    className: "cls-7",
    transform: "translate(1197 762)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Block Stealing")), /*#__PURE__*/React.createElement("text", {
    id: "Draw_2_influences",
    "data-name": "Draw 2 influences",
    className: "cls-11",
    transform: "translate(877 749)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Draw 2 influences")), /*#__PURE__*/React.createElement("text", {
    id: "and_put_2_back",
    "data-name": "and put 2 back",
    className: "cls-11",
    transform: "translate(893 778)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "and put 2 back")))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9",
    "data-name": "Group 9",
    transform: "translate(-286 -211)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_8",
    "data-name": "Rectangle 8",
    className: "cls-12",
    transform: "translate(318 831)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    width: 1136,
    height: 82,
    rx: 5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 0.5,
    y: 0.5,
    width: 1135,
    height: 81,
    rx: 4.5
  })), /*#__PURE__*/React.createElement("text", {
    id: "CAPTAIN",
    className: "cls-7",
    transform: "translate(367 885)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "CAPTAIN")), /*#__PURE__*/React.createElement("text", {
    id: "STEAL",
    className: "cls-7",
    transform: "translate(670 884)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "STEAL")), /*#__PURE__*/React.createElement("text", {
    id: "Block_Stealing-2",
    "data-name": "Block Stealing",
    className: "cls-7",
    transform: "translate(1202 884)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Block Stealing")), /*#__PURE__*/React.createElement("text", {
    id: "Draw_2_coins_from",
    "data-name": "Draw 2 coins from",
    className: "cls-11",
    transform: "translate(877 866)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Draw 2 coins from")), /*#__PURE__*/React.createElement("text", {
    id: "another_player",
    "data-name": "another player",
    className: "cls-11",
    transform: "translate(897 895)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "another player")))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10",
    "data-name": "Group 10",
    transform: "translate(-286 -214)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_1",
    "data-name": "Path 1",
    className: "cls-13",
    transform: "translate(318 921)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M 1131 81.5 L 5 81.5 C 2.518714189529419 81.5 0.5 79.48128509521484 0.5 77 L 0.5 5 C 0.5 2.518714189529419 2.518714189529419 0.5 5 0.5 L 1131 0.5 C 1133.481323242188 0.5 1135.5 2.518714189529419 1135.5 5 L 1135.5 77 C 1135.5 79.48128509521484 1133.481323242188 81.5 1131 81.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M 5 1 C 2.79443359375 1 1 2.794425964355469 1 5 L 1 77 C 1 79.20557403564453 2.79443359375 81 5 81 L 1131 81 C 1133.20556640625 81 1135 79.20557403564453 1135 77 L 1135 5 C 1135 2.794425964355469 1133.20556640625 1 1131 1 L 5 1 M 5 0 L 1131 0 C 1133.761474609375 0 1136 2.238571166992188 1136 5 L 1136 77 C 1136 79.76142883300781 1133.761474609375 82 1131 82 L 5 82 C 2.238525390625 82 0 79.76142883300781 0 77 L 0 5 C 0 2.238571166992188 2.238525390625 0 5 0 Z"
  })), /*#__PURE__*/React.createElement("text", {
    id: "CONTESSA",
    className: "cls-7",
    transform: "translate(349 973)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "CONTESSA")), /*#__PURE__*/React.createElement("text", {
    id: "Block_Assassination",
    "data-name": "Block Assassination",
    className: "cls-7",
    transform: "translate(1163 973)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Block Assassination")), /*#__PURE__*/React.createElement("text", {
    id: "_8",
    "data-name": "\\u2014\\u2014\\u2014\\u2014\\u2014",
    className: "cls-7",
    transform: "translate(637 973)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2014\u2014\u2014\u2014\u2014")), /*#__PURE__*/React.createElement("text", {
    id: "_9",
    "data-name": "\\u2014\\u2014\\u2014\\u2014\\u2014",
    className: "cls-7",
    transform: "translate(905 973)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2014\u2014\u2014\u2014\u2014")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheatSheet);
export default __webpack_public_path__ + "static/media/CheatSheet.c4600c56c39e1615616588f688729bad.svg";
export { ForwardRef as ReactComponent };